import { useMutation } from "react-query";
import uploadFile from "./uploadFile";

export const useUploadMedia = () => useMutation((file: File): Promise<string> => uploadFile(file));
